import { Activity, FunctionComponent, memo } from 'react';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { ESpeakerInviteStatus, Speaker } from '@/types/speakers.types';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type CustomRenderProps = FunctionComponent<{ option: TReactSelectOption; idx: number }>;

const RenderUnfocusedLabelContent: CustomRenderProps = memo(({ option }) => {
  const speaker = option.meta as Speaker;
  return (
    <div className="flex ai-center gap-8 height-100-percent">
      <div className="square-24 radius-6 position-relative">
        <img
          style={{ backgroundColor: 'var(--BG)' }}
          className="radius-6 image-cover"
          height={24}
          width={24}
          src={speaker.image || undefined}
        />{' '}
        <Activity mode={speaker.invite_status === ESpeakerInviteStatus.pending ? 'visible' : 'hidden'}>
          <div
            className="position-absolute radius-full flex ai-center pc-center square-14"
            style={{
              top: 'calc(100% - 8px)',
              left: 'calc(100% - 8px)',
              background: 'var(--primitives-mode-1-orange-500)',
              border: '1px solid var(--BG)',
            }}
          >
            <Icon name={ICONS.SEND_3} size={8} color="var(--BG)" />
          </div>
        </Activity>
      </div>
      <Text clamp={1} wordBreak="break-all">
        {speaker.first_name} {speaker.last_name}
      </Text>{' '}
    </div>
  );
});

RenderUnfocusedLabelContent.displayName = 'RenderUnfocusedLabelContent';

export default RenderUnfocusedLabelContent;
